const localstore = function reducer(
	state = {
		icons: [],
		filter_category: [],
		category: null,
		fetching: false,
		fetched: false,
		error: null
	},
	action
) {
	switch (action.type) {
		case 'FETCHING_FILTER_ICONS': {
			return { ...state, fetching: true }
		}
		case 'FETCH_FILTER_ICONS_REJECTED': {
			return { ...state, fetching: false, error: action.payload }
		}

		case 'FETCHED_FILTER_ICONS': {
			return {
				...state,
				fetching: true,
				fetched: true,
				icons: action.payload
			}
		}
		case 'FETCHED_CATEGORY': {
			return {
				...state,
				fetching: true,
				fetched: true,
				category: action.payload
			}
		}
		case 'FETCHED_FILTER_CATEGORY': {
			return {
				...state,
				fetching: true,
				fetched: true,
				filter_category: action.payload
			}
		}
		case 'FETCHED_FILTER_ICON_AND_CATEGORY': {
			return {
				...state,
				fetching: false,
				fetched: true,
				icons: action.payload,
				filter_category: action.category
			}
		}
		case 'SET_ICONS': {
			return {
				...state,
				icons: action.payload,
			}
		}
	}
	return state
}
export default localstore
